<template>
  <footer class="er-footer" :class="{ 'is-last-page': lastPage }">
    <p class="er-footer__contact">
      <component
        :is="part.href ? 'a' : 'span'"
        v-for="(part, idx) in parts"
        :key="idx"
        :href="part.href || null"
        :dir="part.ltr ? 'ltr' : null"
        :class="{ 'er-ltr': rtl && part.ltr }"
      >{{ part.text }}</component>
    </p>
    <p class="er-footer__copy">{{ copy }}</p>
  </footer>
</template>

<script>
export default {
  name: 'ExecutiveReportPageFooter',
  props: {
    parts: { type: Array, default: () => [] },
    copy: { type: String, default: '' },
    rtl: { type: Boolean, default: false },
    lastPage: { type: Boolean, default: false },
  },
}
</script>

<style lang="scss" scoped>
.er-footer {
  position: absolute;
  left: 40px;
  right: 40px;
  bottom: 18px;
  font-size: 10px;
  color: #94a3b8;
  border-top: 1px solid #e2e8f0;
  padding-top: 8px;

  p {
    margin: 0;
  }

  &__contact {
    display: none;
  }

  &__copy {
    font-size: 10px;
  }

  &.is-last-page &__contact {
    display: block;
    margin-bottom: 6px;
    font-size: 12px;
    font-weight: 600;
    color: #334155;

    a {
      color: #0b3b5c;
      text-decoration: underline;
    }
  }
}

.er-ltr {
  unicode-bidi: isolate;
  direction: ltr;
  white-space: nowrap;
}
</style>
